import { render, staticRenderFns } from "./contribution.vue?vue&type=template&id=0820752e&scoped=true&"
import script from "./contribution.vue?vue&type=script&lang=js&"
export * from "./contribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0820752e",
  null
  
)

export default component.exports